const HEAP_TRACK = 'track';

export const heapTrackClick = (eventName: string, dimensions: Record<string, unknown>) => {
    if (typeof window === 'undefined') return false;
    if (typeof window.dataLayer === 'undefined') return false;
    window?.dataLayer.push({
        event: HEAP_TRACK,
        sendToHeap: true,
        eventName: eventName,
        eventData: {
            ...dimensions,
        },
    });
};
